module.exports = __webpack_public_path__ + "fonts/InstagramSansCondensed-Regular.788ccac8.woff2";